





















import Vue from 'vue'
import { mdiTruckDelivery } from '@mdi/js'
import { BaseFieldEmail } from '@/components'
import { FieldOrderNumber } from './components'
import { createNamespacedHelpers } from 'vuex'
import { STORE_MODULES, ACTIONS_ORDER, ROUTES } from '@/enums'

const { mapActions } = createNamespacedHelpers(STORE_MODULES.ORDER)

export default Vue.extend({
    name: 'OrderDeliveryForm',

    components: { BaseFieldEmail, FieldOrderNumber },

    data: () => ({
        orderCredentials: {
            email: '',
            orderNumber: '',
        },
        isRequestInProgress: false,
        mdiTruckDelivery,
    }),

    computed: {
        isMobile(): boolean {
            return this.$vuetify.breakpoint.xsOnly
        },
    },

    methods: {
        ...mapActions({ fetchOrderCode: ACTIONS_ORDER.FETCH_ORDER_CODE }),

        async submit(): Promise<void> {
            // @ts-ignore
            if (!this.$refs.form.validate()) return

            this.isRequestInProgress = true

            const orderCode = await this.fetchOrderCode(this.orderCredentials)

            if (orderCode) {
                this.$router.push({ name: ROUTES.ORDER_DETAILS, params: { orderCode } })
            }

            this.isRequestInProgress = false
        },
    },
})
